// @ts-nocheck
import tryJsonParse from "@store/Framework/Common/Utilities/tryJsonParse";

/**
 * A product can have one lead time / full truck load entry per plant, so a match on ProductNumber
 * alone isn't enough - prefer the entry for the given plant, falling back to the first entry if
 * the plant isn't known yet.
 * @param json The serialized entry collection, as received from the API.
 * @param productNumber The product number to filter the entries by.
 * @param plant The plant to prefer.
 * @returns The matching entry, or "undefined" when the product has no entries.
 */
const resolveEntryForPlant = <T extends { ProductNumber: string; Plant: string }>(
    json: string | undefined,
    productNumber: string | undefined,
    plant: string | undefined,
): T | undefined => {
    const entriesForProduct = tryJsonParse<T[]>(json)?.filter(x => x.ProductNumber === productNumber);
    return entriesForProduct?.find(x => x.Plant === plant) ?? entriesForProduct?.[0];
};

export default resolveEntryForPlant;
